/**
 * BlueConic profile properties only used on Tou.tv
 */
export enum ToutvBlueConicProfileProperties {
  /**
   * The last time the user started the subscription process.
   */
  LastStartSubscriptionProcessDate = "RC_TouTV_start_subscription_process_date",

  /**
   * The last time the user completed the subscription process.
   */
  LastEndSubscriptionProcessDate = "RC_TouTV_complete_subscription_process_date",
}
